import React, { FC } from 'react';
import AbschlussSeiteBox from 'src/pages/private/online-antrag/antrag-components/AbschlussSeiteBox';
import {
	SummaryBeantragteFoerderquote,
	SummaryBeantragteFoerderung,
	SummaryDatumDerEinreichung,
	SummaryGeplanteProjektAusgabe,
	SummaryGeplanteProjektLaufzeit,
	SummaryNameDerOrganisation,
	SummaryOrganisationAntragberechtigtAls,
	SummaryProjektTitel,
	SummaryTitel,
	SummaryVorzeitigerVorhabenBeantragt,
	SummaryVorzeitigerVorhabenLaufzeit,
} from 'src/pages/private/online-antrag/antrag-components/AbschlussSeiteSummary';

const AbschlussAntragKreativwirtschaft: FC<{}> = () => {
	return (
		<>
			<SummaryTitel />
			<AbschlussSeiteBox>
				<SummaryDatumDerEinreichung />

				<SummaryProjektTitel />

				<SummaryNameDerOrganisation />
				<SummaryOrganisationAntragberechtigtAls />

				<SummaryVorzeitigerVorhabenBeantragt />
				<SummaryGeplanteProjektLaufzeit />
				<SummaryVorzeitigerVorhabenLaufzeit />

				<SummaryGeplanteProjektAusgabe />
				<SummaryBeantragteFoerderung />
				<SummaryBeantragteFoerderquote />
			</AbschlussSeiteBox>
		</>
	);
};

export default AbschlussAntragKreativwirtschaft;
